import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import { Options, Select } from '../../components/Select';

import api from '../../services/api';
import './style.css';

import MultiCheckBox, { OptionType, OnSelectFunction } from '../../components/MultiCheckBox';
import { useNavigate } from 'react-router-dom';

export function ProdutosCadastrar() {
    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [nome, setNome] = useState("");
    const [descricao, setDescricao] = useState("");
    const [duracao, setDuracao]: any = useState();
    const [preco, setPreco]: any = useState(null);
    const [itens, setItens] = useState<OptionType[]>([]);
    const [selectedItens, setSelectedItens] = useState<string[]>([]);
    const [tipoProduto, setTipoProduto] = useState('Produto');
    const [profissionalSelecionado, setProfissionalSelecionado]: any = useState(null);
    console.log("🚀 ~ ProdutosCadastrar ~ profissionalSelecionado:", profissionalSelecionado)
    const tipos = ['Produto', 'Global', 'Adicional', 'Reaproveitamento de Aso'];
    const tipoProfissional = [
        {
            id: 1,
            nome: 'Trabalhador'
        },
        {
            id: 2,
            nome: 'Empresa'
        }
    ]

    {/* Informações de Funções */ }
    const [quantidadeFuncao, setQuantidadeFuncao]: any = useState(null);

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const navigate = useNavigate()

    const duracaoPlano = [
        { id: 96, nome: '96 Horas' },
        { id: 72, nome: '72 Horas' },
        { id: 48, nome: '48 Horas' },
        { id: 24, nome: '24 Horas' }
    ];


    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    useEffect(() => {
        const buscarItens = async () => {

            try {
                const response = await api.get(`itens/listar`);
                const itensData = response.data;
                const options: OptionType[] = [];

                itensData.map((item: any) => {
                    options.push({ value: item.id, name: item.nome, color: 'blue' });
                })

                setItens(options);
            } catch (error) {
                console.error('Erro ao buscar itens', error);
            }
        };

        buscarItens();
    }, []);

    const parseInputValue = (inputValue: string) => {
        const sanitizedValue = inputValue.replace(/[^0-9.,]/g, '');

        const normalizedValue = sanitizedValue.replace(/(\..*)\./g, '$1');

        return normalizedValue;
    };

    const handleSelect: OnSelectFunction = (selectedValues) => {
        console.log('Valores selecionados:', selectedValues);
        setSelectedItens(selectedValues);
    };

    const handleSelectDuracao = (duracaoHoras: any) => {
        setDuracao(duracaoHoras);
    };


    const handleSubmit = async (event: any) => {
        event.preventDefault();

        const itensPayload = [
            { id: 1 },
            { id: 2 }
        ];


        let isValid = true;

        if (!nome) {
            setAlert({ message: 'Por favor, preencha o campo nome', variant: 'danger', show: true });
            isValid = false;
        }
        if (!descricao) {
            setAlert({ message: 'Por favor, preencha o campo descrição.', variant: 'danger', show: true });
            isValid = false;
        }
        if (!preco) {
            setAlert({ message: 'Por favor, preencha o campo preço ou verifique seu valor!', variant: 'danger', show: true });
            isValid = false;
        }
        // if (!quantidadeFuncao) {
        //     setAlert({ message: 'Por favor, preencha o campo quantidade de funções.', variant: 'danger', show: true });
        //     isValid = false;
        // }



        if (nome && descricao && preco) {
            isValid = true;
        }

        try {
            if (isValid) {
                const precoFormatado = preco ? parseFloat(preco.replace(',', '.')).toFixed(2) : null;

                if (tipoProduto === 'Produto' || tipoProduto === 'Reaproveitamento de Aso') {
                    const payload = {
                        nome,
                        descricao,
                        preco: precoFormatado,
                        quantidade_funcao: quantidadeFuncao,
                        itens: itensPayload,
                        tipo: tipoProduto,
                        tipo_produto: profissionalSelecionado
                    };
                    await api.post('produtos/cadastro', payload);
                    setNome('');
                    setDescricao('');
                    setPreco(null);
                    setQuantidadeFuncao(null);
                    setAlert({ message: 'Produto cadastrado!', variant: 'success', show: true });

                    setTimeout(() => {
                        navigate('/produtos');
                    }, 1000);
                } else {
                    const payload = {
                        nome,
                        descricao,
                        preco: precoFormatado,
                        tipoProduto: tipoProduto,
                        quantidadeFuncao: quantidadeFuncao
                    };
                    await api.post('adicionais/cadastro', payload);
                    setNome('');
                    setDescricao('');
                    setPreco(null);
                    setQuantidadeFuncao(null);
                    setAlert({ message: 'Adicional cadastrado!', variant: 'success', show: true });

                    setTimeout(() => {
                        navigate('/produtos');
                    }, 1000);
                }
            }
        } catch (error) {
            console.error('Erro ao enviar dados do formulário:', error);
        }
    };

    const handleSelectType = (type: any) => {
        setProfissionalSelecionado(type);
    }

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Informações Gerais</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                {tipos.map((option) => (
                                    <div key={option} style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                                        <input
                                            type="radio"
                                            name="tipoProduto"
                                            id={`tipo-${option}`}
                                            value={option}
                                            checked={tipoProduto === option}
                                            onChange={(e) => setTipoProduto(e.target.value)}
                                            style={{ width: '14px', marginRight: '10px' }}
                                        />
                                        <label htmlFor={`tipo-${option}`}>{option}</label>
                                    </div>
                                ))}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            {tipoProduto == 'Reaproveitamento de Aso' && (
                                <>
                                    <Label title='TIpo do Produto' htmlFor="nome" />
                                    <Select width="600px" id='empresas' onSelect={handleSelectType}>
                                        {tipoProfissional.map((company: any, index: any) => (
                                            <Options key={company.id} value={company.id} name={company.nome} />
                                        ))}
                                    </Select></>
                            )}
                        </Col>
                    </Row>
                    <Row>


                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Nome' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label title='Descrição' htmlFor="descricao" />
                                <textarea
                                    id="descricao"
                                    placeholder="Digite a descrição"
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    style={{ width: '100%', minHeight: '100px' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    {tipoProduto == 'Produto' ? (
                        <>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <Label title='Preço' htmlFor="preco" />
                                        <input
                                            type="text"
                                            id="preco"
                                            placeholder="Escolha o preço do produto"
                                            onChange={(e) => setPreco(e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h3 style={{ marginTop: 15 }}>Informações sobre as Funções</h3>
                            <Row>
                                <Col xs={12} md={3}>
                                    <FormGroup>
                                        <Label title='Quantidade de Funções' htmlFor="quantidade_funcao" />
                                        <input
                                            type="number"
                                            id="quantidade_funcao"
                                            placeholder="digite a quantidade de funções"
                                            value={quantidadeFuncao}
                                            onChange={(e) => setQuantidadeFuncao(parseInt(e.target.value))}
                                            style={{ width: '100%' }} />

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button className="btn-main mt-4" type="submit">Inserir Produto</Button>
                        </>
                    ) : tipoProduto == 'Adicional' || tipoProduto == 'Global' ? (
                        <>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <Label title='Preço' htmlFor="preco" />
                                        <input
                                            type="text"
                                            id="preco"
                                            placeholder={tipoProduto === 'Adicional' ? 'Preço do Adicional' : 'Preço da Global'}
                                            onChange={(e) => setPreco(e.target.value)}
                                            style={{ width: '100%' }} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h3 style={{ marginTop: 15 }}>Informações sobre as Funções</h3>
                            <Row>
                                <Col xs={12} md={3}>
                                    <FormGroup>
                                        <Label title='Quantidade de Funções' htmlFor="quantidade_funcao" />
                                        <input
                                            type="number"
                                            id="quantidade_funcao"
                                            placeholder="digite a quantidade de funções"
                                            value={quantidadeFuncao}
                                            onChange={(e) => setQuantidadeFuncao(parseInt(e.target.value))}
                                            style={{ width: '100%' }} />

                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button className="btn-main mt-4" type="submit">{tipoProduto == 'Adicional' ? 'Inserir Adicional' : 'Inserir Global'}</Button>
                        </>
                    ) : (
                        <>
                            <Row>
                                <Col xs={12} md={3} xl={3}>
                                    <FormGroup>
                                        <Label title='Preço' htmlFor="preco" />
                                        <input
                                            type="text"
                                            id="preco"
                                            placeholder="Escolha o preço do produto"
                                            onChange={(e) => setPreco(e.target.value)}
                                            style={{ width: '100%' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Button className="btn-main mt-4" type="submit">Inserir Produto</Button>
                        </>
                    )}

                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
